import axios from "axios";
import { BASE_URL } from "./url";

// image upload used to live in a standalone service that authenticated with a
// shared bearer token. that token shipped inside this bundle, so anyone reading
// the compiled js could write to and delete from the bucket. uploads now go to
// the platform api and are authorised by the session cookie like every other
// mutating call, which is why this instance sets withCredentials
const platformApi = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
});

export const uploadImage = async (file, cb = () => {}) => {
    try {
        const formData = new FormData();
        formData.append("image", file);
        const res = await platformApi.post("/mentors/image", formData, {
            onUploadProgress: cb,
        });
        return res.data;
    } catch (error) {
        console.log(error);
        // the api answers 401/413/415 with a json body, and callers read
        // result.ok and result.message off whatever comes back. returning the
        // raw axios error the way this used to would put "undefined" in the
        // snackbar instead of the reason the upload was refused
        return (
            error.response?.data || {
                ok: false,
                message: "Image upload failed",
            }
        );
    }
};

export const deleteImage = async (url) => {
    try {
        const body = {
            imgUrl: url,
        };

        const res = await platformApi.post("/mentors/delete-image", body);

        return res.data;
    } catch (error) {
        console.log(error);
        return (
            error.response?.data || {
                ok: false,
                message: "Image delete failed",
            }
        );
    }
};
